import { createRouter, createWebHistory } from 'vue-router';
import HomeIndexView from '../views/home/index.vue';
import PollShowView from '../views/polls/show.vue';
import PollFormView from '../views/polls/form.vue';
import ProfileIndexView from '../views/profile/index.vue';
import ForgotPasswordView from '../views/home/forgot-password.vue';
import ResetPasswordView from '../views/home/reset-password.vue';
import ActivityCenterView from '../views/activity-center/index.vue';
import AuthSocialCallbackView from '../views/auth/social-callback.vue';
import NotFoundView from '../views/errors/NotFound.vue';

const routes = [
    { path: '/', name: 'home', component: HomeIndexView },
    { path: '/polls/create', name: 'polls.create', component: PollFormView },
    { path: '/polls/:id/edit', name: 'polls.edit', component: PollFormView },
    { path: '/sondaje/:id(\\d+)-:slug(.+)', name: 'polls.show', component: PollShowView },
    { path: '/profile', name: 'profile', component: ProfileIndexView },
    { path: '/forgot-password', name: 'forgot-password', component: ForgotPasswordView },
    { path: '/reset-password', name: 'reset-password', component: ResetPasswordView },
    { path: '/activity-center', name: 'activity-center', component: ActivityCenterView },
    { path: '/auth/social', name: 'auth.social', component: AuthSocialCallbackView },
    { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFoundView },
    { path: '/404', name: 'not-found-page', component: NotFoundView },
];

export default createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition;
        return { top: 0 };
    },
});
